import { render, staticRenderFns } from "./PromptsDetails.vue?vue&type=template&id=570954fd"
import script from "./PromptsDetails.vue?vue&type=script&lang=js"
export * from "./PromptsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports